module.exports = __webpack_public_path__ + "img/pijltje-rechts-rood.f1331b6ec3e1c6160c1782acac78794a.svg";